import { render, staticRenderFns } from "./skeleton-loader.vue?vue&type=template&id=32bc574c&scoped=true&"
import script from "./skeleton-loader.vue?vue&type=script&lang=ts&"
export * from "./skeleton-loader.vue?vue&type=script&lang=ts&"
import style0 from "./skeleton-loader.vue?vue&type=style&index=0&id=32bc574c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32bc574c",
  null
  
)

export default component.exports